// 融资订单 状态options
export const financingStatusOptions = [
    {
        label: '已申请',
        value:'APPLIED',
        status: "success"
    },
    {
        label: '审核拒绝',
        value:'APPROVAL_FAIL',
        status: "error"
    },
    {
        label: '协议待签署',
        value:'CONTRACT_TO_BE_SIGNED',
        status: "warning"
    },
    {
        label: '待放款',
        value:'PENDING_LOAN',
        status: "warning"
    },
    {
        label: '放款失败',
        value:'LOAN_FAIL',
        status: "error"
    },
    {
        label: '待还款',
        value:'PENDING_REPAYMENT',
        status: "default"
    },
    {
        label: '部分还款',
        value:'PARTIAL_REPAYMENT',
        status: "processing"
    },
    {
        label: '还款完成',
        value:'REPAYMENT_COMPLETE',
        status: "success"
    },
    {
        label: '已逾期',
        value:'OVERDUE',
        status: "error"
    },
]


export const repaymentModeObj = {
    'REPAID_ONCE_DUE':'到期一次还本付息'
}
